import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axios";

export const getAgsReportList = createAsyncThunk("/ags-report", async () => {
  const response = await axiosInstance.get("user/get-reports-list-cr");
  return response.data.data.AgsReportList;
});
